import Placeholder from '@assets/imagePlaceholderB&W.png';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { faCircleCheck, faCircleExclamation, faDownload, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import {
  StyledDownloadPlaceholder,
  StyledExportButton,
  StyledFileIcon,
  StyledImage,
  StyledTitleIcon,
} from './MeasurmentExportStyles';

const DownloadInfo = ({
  border,
  type,
  submitValues,
}: {
  border: boolean;
  type: 'noParameters' | 'noDataFound' | 'partialDataFound' | 'dataFound' | 'changedDevices';
  submitValues: () => void;
}) => {
  const { t } = useTranslation();

  const info = {
    noParameters: {
      title: t('measurementExport.parameters.placeholder.title'),
      titleIcon: undefined,
      description: t('measurementExport.parameters.placeholder.description'),
      image: <StyledImage src={Placeholder} />,
      downloadButton: undefined,
    },
    changedDevices: {
      title: t('measurementExport.parameters.changedDevices.title'),
      titleIcon: undefined,
      description: t('measurementExport.parameters.changedDevices.description'),
      image: <StyledImage src={Placeholder} />,
      downloadButton: undefined,
    },
    noDataFound: {
      title: t('measurementExport.parameters.noDataFound.title'),
      titleIcon: <StyledTitleIcon error={true} icon={faCircleExclamation} />,
      description: t('measurementExport.parameters.noDataFound.description'),
      image: <StyledFileIcon icon={faFileExcel} />,
      downloadButton: undefined,
    },
    partialDataFound: {
      title: t('measurementExport.parameters.partialDataFound.title'),
      titleIcon: <StyledTitleIcon icon={faCircleCheck} />,
      description: t('measurementExport.parameters.partialDataFound.description'),
      image: <StyledFileIcon icon={faDownload} />,
      downloadButton: (
        <StyledExportButton
          buttonType={'filledPrimary'}
          textContent={t('general.tooltip.export')}
          onClick={submitValues}
        />
      ),
    },
    dataFound: {
      title: t('measurementExport.parameters.dataFound.title'),
      titleIcon: <StyledTitleIcon icon={faCircleCheck} />,
      description: t('measurementExport.parameters.dataFound.description'),
      image: <StyledFileIcon icon={faDownload} />,
      downloadButton: (
        <StyledExportButton
          buttonType={'filledPrimary'}
          textContent={t('general.tooltip.export')}
          onClick={submitValues}
        />
      ),
    },
  };

  return (
    <StyledDownloadPlaceholder showBorder={border}>
      <TypographyTsoPq typographyType={'pageTitleBold'}>
        {info[type].titleIcon}
        {info[type].title}
      </TypographyTsoPq>
      <TypographyTsoPq typographyType={'pageSubtitleMD'}>{info[type].description}</TypographyTsoPq>
      {info[type].image}
      {info[type].downloadButton}
    </StyledDownloadPlaceholder>
  );
};

export default DownloadInfo;
